import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Paquetesfeatured() {
    const { csrfToken } = useCsrfToken();
    const [paquetes, setPaquetes] = useState([]);

    const API_URL = process.env.REACT_APP_API_URL;
    useEffect(() => {
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Paquetes',
                name: item.title,
                slug: item.slug,
                desc: item.description.length > 50 ? item.description.substring(0, 50) + '...' : item.description,
                package_type: item.package_type,
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/package/1/1`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setPaquetes(transformData(data)))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, csrfToken]);
    return (
        <>
            <div className="row justify-content-center">
                {paquetes.slice(0, 6).map((item, index) => {
                    const stripTags = (html) => {
                        let doc = new DOMParser().parseFromString(html, 'text/html');
                        let textContent = doc.body.textContent || "";
                        return textContent.normalize("NFC");
                    };
                    return (
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="paquetes position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                <div className="position-relative">
                                    <div className="paquetes-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                        <Link to={`/paquete/${item.slug}`}>
                                            <img src={item.image} className="img-fluid notransition" alt={item.name} />
                                        </Link>
                                    </div>

                                    <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                        <span className="badge text-dark bg-light">{item.tag}</span>
                                    </div>
                                </div>

                                <div className="pt-4 flex-grow-1 d-flex flex-column">
                                    <Link to={`/paquete/${item.slug}`} className="text-light title h5 hv:text-light">{item.name}</Link>

                                    <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>

                                    <Link to={`/paquete/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">
                                        {item.package_type === 'pricebased' && (
                                            <>
                                                Comprar <i className="mdi mdi-chevron-right align-middle"></i>
                                            </>
                                        )}
                                        {item.package_type === 'percentagebased' && (
                                            <>
                                                Más información <i className="mdi mdi-chevron-right align-middle"></i>
                                            </>
                                        )}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
